import type { TOC } from '@ember/component/template-only';

interface SettingsPanelSkeletonSignature {
  Element: HTMLDivElement;
}

// Column classes are copied from sp-header so the real header replaces this without shifting.
export default <template>
  <div
    class="flex items-center bg-white min-h-[38px] motion-safe:animate-pulse"
    data-test-settings-panel-skeleton
    ...attributes
  >
    <span class="sr-only">Loading setting</span>

    <div class="flex-none pr-4 w-[34px] h-[34px] mx-legacy-icon box-content" aria-hidden="true">
      <div class="w-full h-full rounded bg-carbon-10"></div>
    </div>

    <div class="flex-auto min-w-0 pr-4" aria-hidden="true">
      <div class="h-5 w-52 max-w-full rounded bg-carbon-10"></div>
      <div class="h-4 w-80 max-w-full rounded bg-carbon-10 mt-2"></div>
    </div>

    <div class="flex-none m-[3px]" aria-hidden="true">
      <div class="h-8 w-[60px] rounded-full bg-carbon-10"></div>
    </div>
  </div>
</template> satisfies TOC<SettingsPanelSkeletonSignature>;
